<p-floatlabel class="w-full flex-1 block p-fluid" [formGroup]="formGroup">
  <p-autocomplete styleClass="w-full"
    [inputId]="id"
    [formControlName]="id"
    [multiple]="true"
    [typeahead]="false"
    [separator]="','"
    [addOnBlur]="true"
    [unique]="true"
    [showClear]="true"
    [placeholder]="placeholder"
    [suggestions]="chipSuggestions"
    (completeMethod)="onComplete($event)"
    (onAdd)="onChipAdd()">
  </p-autocomplete>
  <label [for]="id">{{label}}</label>
</p-floatlabel>
@if (formError) {
  <app-form-error [message]="formError"></app-form-error>
}
